<template>
    <div class="or-admin-products">
        <div v-show="!selected_product">
            <p class="add nesting-main hover-pointer hover-yellow" @click="add">+ Добавить изделие</p>
            <or-admin-product-card class="card nesting-main" :options="product" @remove="remove(i)" @selected="select(product)" v-for="(product, i) in options" :key="product.id" @unsaved="unsaved"/>
        </div>
        <div class="category_content" v-if="selected_product">
            <or-admin-product-constructor @close="close" :options="selected_product.content"/>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import orAdminProductCard from "../global/or-admin-product-card.vue"
import orAdminProductConstructor from "../global/or-admin-product-constructor.vue"
export default {
    components: {orAdminProductCard, orAdminProductConstructor},
    props: {
        options: Object,
        deleted: Array,
    },
    data() {
        return {
            selected_product: null,
            products: [],
        }
    },
    methods: {
        ...mapActions({addUnsavedPage: 'addUnsavedPage',
                        changeAdmin: 'changeAdmin'}),
        unsaved() {
            this.addUnsavedPage({page: 'products'})
        },
        add() {
            this.options.unshift({
                id: this.get_id(this.options),
                title: {
                    title: 'Название изделия',
                    value: 'Безымянное изделие',
                },
                description: {
                    title: 'Краткое описание изделия',
                    value: 'Описание...',
                },
                image: null,
                content: [],
                production_category_id: -1,
                production_category_name: null,
                buyers_category_id: -1,
                buyers_category_name: null,
                production_categories: this.$parent.$parent.production_categories,
                buyers_categories: this.$parent.$parent.buyers_categories,
                input_postfix: 'product',
            })
            this.addUnsavedPage({page: 'products'})
        },
        remove(index) {
            const deleted = this.options.splice(index, 1)[0];
            this.deleted.push(deleted.id);
            this.addUnsavedPage({page: 'products'})
        },
        select(product) {
            this.selected_product = product;
        },
        get_id(options) {
            let id = 0;
            options.map(el=>{
                if (el.id > id) {
                    id = el.id
                }
            })
            return id + 1;
        },
        close() {
            this.changeAdmin({property: 'show_inner_edit', value: false});
            this.changeAdmin({property: 'show_edit', value: false});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            this.changeAdmin({property: 'show_image_edit', value: false});
            this.selected_product = null
        }
    }
    
}
</script>

<style scoped>
    .card {
        margin-bottom: 50px;
    }
    .add {
        font-size: 14px;
        line-height: 16px;
        margin-top: 50px;
        text-align: left;
        margin-bottom: 50px;
        color: #3dc986;
    }
</style>